// if (window.location.href.includes('/products/') && window.innerWidth < 800) {
//     let getTitle = document.querySelector('.prod_title-review')
//     let getRev = document.querySelector('.prod_title-review + .product__app')
//     let getGall = document.querySelector('.product__grid-left')
//     if (getTitle && getRev && getGall) {
//         getGall.insertAdjacentElement('afterbegin', getRev)
//         getGall.insertAdjacentElement('afterbegin', getTitle)    
//     }
// }

let getreferId = localStorage.getItem('__referral_id')
if (getreferId) {
    addAttribute(getreferId)
}else {
    addAttribute('...')
}


function addAttribute(getLink) {
    if (getLink) {
        fetch(window.Shopify.routes.root + 'cart.js', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
        })
        .then(response => response.json())
        .then(cart => {
        let currentAttributes = cart.attributes || {};
        currentAttributes.__referral_id = getLink;
        let updates = {
            attributes: currentAttributes
        };
        return fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json'
            },
            body: JSON.stringify(updates)
        });
        })
        .then(response => response.json())
        .then(updatedCart => {
            console.log("Cart attributes updated", updatedCart);
        })
        .catch(error => {
            console.error('Error updating cart attributes:', error);
        });
    }
}


const reviewContents = document.querySelectorAll('.shopify-section:not(#shopify-section-template--24668403040551__home_alternating_content_9DpLjN) .home-left-right-text .rte-caption');

reviewContents.forEach(function (contentDiv) {
    const fullText = contentDiv.innerHTML.trim();
    const charLimit = 300; // ← Yahan character limit set karein

    if (fullText.length <= charLimit) return;

    const shortText = fullText.slice(0, charLimit) + ' ...';
    contentDiv.setAttribute('data-full-text', fullText);
    contentDiv.setAttribute('data-short-text', shortText);
    contentDiv.innerHTML = shortText;
    const button = document.createElement('button');
    button.className = 'readmoreleassbtn';
    button.textContent = 'Read more';
    contentDiv.appendChild(button);

    button.addEventListener('click', function () {
    const isExpanded = button.innerText === 'Read less';
    if (isExpanded) {
        contentDiv.innerHTML = contentDiv.getAttribute('data-short-text');
        contentDiv.appendChild(button);
        button.innerText = 'Read more';
    } else {
        contentDiv.innerHTML = contentDiv.getAttribute('data-full-text');
        contentDiv.appendChild(button);
        button.innerText = 'Read less';
    }
    });
});

document.addEventListener("DOMContentLoaded", function() {
    var showChar = 50;
    var ellipsestext = ".......";
    var moretext = "Read more";

    var paragraphs = document.querySelectorAll('.home-left-right-features .rte p');
    
    paragraphs.forEach(function(paragraph) {
        var content = paragraph.textContent;
        var words = content.split(' ');

        if (words.length > showChar) {
            var shown = words.slice(0, showChar).join(' ');
            var hidden = words.slice(showChar).join(' ');
            var html = shown + '<span class="moreelipses">' + ellipsestext + '</span>' +
                        '<span class="morecontent" style="display:none;"><span>' + hidden + '</span></span>' +
                        '<a href="#" class="morelink">' + moretext + '</a>';
            paragraph.innerHTML = html;
        }
    });

    document.addEventListener("click", function(e) {
        if (e.target && e.target.classList.contains('morelink')) {
            e.preventDefault();
            var moreLink = e.target;
            var moreContent = moreLink.previousElementSibling;
            var moreEllipses = moreContent.previousElementSibling;

            if (moreContent.style.display === 'none') {
                moreContent.style.display = 'inline';
                moreLink.style.display = 'none';
                moreEllipses.innerHTML = ' ';
            }
        }
    });
});




document.querySelectorAll('a[href="#product-form-t"]').forEach(a => {
    a.addEventListener('click', function(e) {
        e.preventDefault()
        let link = this.getAttribute('href')
        if(link == '#product-form-t'){
            const targetDiv = document.getElementById("product-form-t");
            const offset = 150; // Adjust this value to scroll slightly below the top
            const targetPosition = targetDiv?.offsetTop - offset;
            window.scrollTo({
                top: targetPosition,
                behavior: "smooth"
            });
        }
    })
})
console.log('this is cart')

// $(".has-subscription-product .btn_link, .has-subscription-product .cta-shop, .has-subscription-product .home-inline-cta a, .has-subscription-product .image-with-text-overlay__button").click(function() {    
//   $("#custom-add2cart1").click();
// });


document.querySelector('.site-header__account-wrap').addEventListener('click', function() {
    if (this.querySelector('.header-nav__tier-2').getAttribute('data-animation-state') == 'open') {
        this.querySelector('.header-nav__tier-2').setAttribute('data-animation-state', 'close')
    }else {
        this.querySelector('.header-nav__tier-2').setAttribute('data-animation-state', 'open')
    }
})

// document.querySelector('.site-header__account-wrap .header-nav__tier-2').addEventListener('mouseleave', function() {
//     this.setAttribute('data-animation-state', 'close')
// })


if(
    window.location.href.includes('products') || 
    window.location.href.includes('/pages/myvada-joint-plus-nift-30-off') ||
    window.location.href.includes('/pages/respiratoryv2')
) {
    const opinewCheckInterval = setInterval(() => {
    const opinewPluginEl = document.querySelector('opinew-plugin[type="product-stars"]')
    if (!opinewPluginEl || !opinewPluginEl.shadowRoot) return

    const opinewStarsTextEl = opinewPluginEl.shadowRoot.querySelector('.opinew-no-reviews-stars-plugin')
    if (opinewStarsTextEl) {
        const reviewCount = opinewStarsTextEl.textContent.match(/\d+/)?.[0] || ''
        opinewStarsTextEl.innerHTML = `<b>(${reviewCount} Verified Buyer Reviews)</b>`
        clearInterval(opinewCheckInterval)
    }
    }, 10)
}


const interval1 = setInterval(() => {
  const submittedForms =
    JSON.parse(sessionStorage.getItem('klaviyoFormSubmit'))?.submittedForms || {};
  const teaser = document.querySelector('.kl-teaser-VkTXSy');
  if (submittedForms.VkTXSy && teaser) {
    teaser.style.display = 'none';
    clearInterval(interval1);
  }
}, 1000);



function adjustHeaderPosition(retry = 0) {
  const promoBar = document.querySelector('.header-promotion-bar');
  const mainHeader = document.querySelector('.main-header-section');

  if (!mainHeader) return;

  const promoHeight = promoBar?.clientHeight || 0;

  // Retry if height is 0 (max 5 times)
  if (promoHeight === 0 && retry < 5) {
    setTimeout(() => adjustHeaderPosition(retry + 1), 200);
    return;
  }

  mainHeader.style.top = `${promoHeight}px`;
}

adjustHeaderPosition();
document.addEventListener('DOMContentLoaded', adjustHeaderPosition);
window.addEventListener('resize', adjustHeaderPosition);




document.addEventListener('DOMContentLoaded', function () {
    if(!window.location.href.includes('respiratoryv2')) {
        document.querySelectorAll('a[href="#test"]').forEach(btn => {
            btn.addEventListener('click', function (e) {
                e.preventDefault()
                const target = document.querySelector('.loop-w-btn-group-purchase-options-container') // better to use ID
                const header = document.querySelector('.main-header-section')
    
                if (!target || !header) return
    
                let headerHeight = header.offsetHeight + (window.innerWidth < 768 ? 100 : 50)
    
                requestAnimationFrame(() => {
                    const elementTop = target.getBoundingClientRect().top + window.scrollY
    
                    window.scrollTo({
                        top: elementTop - headerHeight,
                        behavior: 'smooth'
                    })
                })
            })
        })
    }
})


// Optimized Kaching Bar Toggle using DOM Observation
function toggleKachingBar() {
    const hasSub = !!document.querySelector('.kaching-cart-item[data-has-selling-plan="true"]');
    let styleTag = document.getElementById('hidden-progress');
    
    if (hasSub) {
        if (!styleTag) {
            styleTag = document.createElement('style');
            styleTag.id = 'hidden-progress';
            styleTag.textContent = '.kaching-cart__tiered-promotions-bar { display: none !important; }';
            document.head.appendChild(styleTag);
        }
    } else if (styleTag) {
        styleTag.remove();
    }
}

// Watch for DOM changes to detect cart drawer updates
const cartObserver = new MutationObserver(() => {
    toggleKachingBar();
});

// Target #kaching-cart specifically
document.addEventListener('DOMContentLoaded', () => {
    toggleKachingBar(); 
    
    // Since #kaching-cart might be added dynamically, we wait for it
    const initObserver = () => {
        const target = document.getElementById('kaching-cart');
        if (target) {
            cartObserver.observe(target, {
                childList: true,
                subtree: true
            });
            console.log('Kaching Observer started on #kaching-cart');
        } else {
            // Retry if not found yet (app might be loading)
            setTimeout(initObserver, 1000);
        }
    };
    initObserver();
});



// if (window.location.pathname.includes('/products/immunity')) {
//   document.querySelector('#custom-add2cart')?.addEventListener('click', (e) => {
//     e.preventDefault()
//     let attempts = 0;
//     const interval = setInterval(() => {
//       const button =
//         document.querySelector('more-payment-options-link a') ||
//         document.querySelector('shopify-buy-it-now-button button');
//         if (button) {
//             button.click();
//             clearInterval(interval);
//         }

//         if (++attempts > 20) clearInterval(interval); // max ~6 sec
//     }, 300);
//   });
// }

